import React, {useState} from "react";
import "./../utils/Style/common.scss";
import {faAnglesLeft, faAnglesRight, faGreaterThan, faLessThan} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const Pagination = (props) => {
    const totalPages = props.totalNbPage;

    const generatePageNumbers = () => {
        const pageNumbers = [];
        let numTabs = 5;

        if (props.totalNbPage < numTabs) {
            numTabs = props.totalNbPage;
        }

        if (props.selectedPage <= Math.floor(numTabs / 2) + 1) {
            for (let i = 1; i <= numTabs; i++) {
                pageNumbers.push(i);
            }
        } else if (props.selectedPage >= totalPages - Math.floor(numTabs / 2)) {
            for (let i = totalPages - numTabs + 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            for (let i = props.selectedPage - Math.floor(numTabs / 2); i <= props.selectedPage + Math.floor(numTabs / 2); i++) {
                pageNumbers.push(i);
            }
        }
        return pageNumbers;
    };


    return (
        <>
            {totalPages !== 0 &&
                <div id="pagination">
                    <button
                        className="btn me-3"
                        disabled={props.selectedPage === 1}
                        onClick={() => {
                            props.setSelectedPage(props.selectedPage - 1);
                            if (props.method === "soa") {
                                props.getData(props.CurrencyID, props.selectedPage - 1, props.startDateString, props.endDateString, props.transactionType)
                            } else if (props.method === "eodClosing") {
                                props.getData(props.selectedPage - 1);
                            }else if(props.method === "cardTransactions") {
                                props.getData(props.cardId || 0, props.holder, props.selectedPage - 1);
                            }
                            else {
                                props.getData(props.selectedPage - 1, props.startDateString, props.endDateString)
                            }

                        }}
                    >
                        <FontAwesomeIcon icon={faAnglesLeft}/>
                    </button>
                    {generatePageNumbers().map((page) => (
                        <button
                            key={page}
                            // disabled={props.selectedPage === totalPages}
                            className={`btn ${page === props.selectedPage ? 'active' : ''}`}
                            onClick={() => {
                                props.setSelectedPage(page);
                                if (props.method === "soa") {
                                    props.getData(props.CurrencyID, page, props.startDateString, props.endDateString, props.transactionType);
                                } else if (props.method === "eodClosing") {
                                    props.getData(page);
                                }else if(props.method === "cardTransactions") {
                                    props.getData(props.cardId || 0, props.holder, page);
                                } else {
                                    props.getData(page, props.startDateString, props.endDateString);
                                }

                            }}
                        >
                            {page < 10 ? `0${page}` : page}
                        </button>
                    ))}
                    <button
                        className="btn ms-4"
                        disabled={props.selectedPage === totalPages}
                        onClick={() => {
                            props.setSelectedPage(props.selectedPage + 1);
                            if (props.method === "soa") {
                                props.getData(props.CurrencyID, props.selectedPage + 1, props.startDateString, props.endDateString, props.transactionType)
                            } else if (props.method === "eodClosing") {
                                props.getData(props.selectedPage + 1)
                            }else if(props.method === "cardTransactions") {
                                props.getData(props.cardId || 0, props.holder, props.selectedPage + 1);
                            }
                            else {
                                props.getData(props.selectedPage + 1, props.startDateString, props.endDateString)
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={faAnglesRight}/>
                    </button>
                </div>
            }
        </>
    );
}

export default Pagination;
